import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileLines, faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";/*faCircleUser, faCircleInfo, faFolder, faAddressBook, faKey*/
import React, {useEffect, useRef, useState} from 'react';
import './budget.scss'
import {Button} from "devextreme-react/button";
import notify from "devextreme/ui/notify";
import {
    getContracts,
    changeContract
} from "../../api/budget";
import {TextBox} from "devextreme-react";
import LoadPanel from "devextreme-react/load-panel";
import {SelectBox} from "devextreme-react/select-box";
import Form, {
    CustomRule, EmailRule, GroupItem, Item, Label,
} from "devextreme-react/form";
import ErrorPopup from "../../components/error-popup/error-popup";
import {useHistory} from "react-router-dom";
import {Buffer} from "buffer";
import NewdogFiles from "../../components/newdog-files/newdog-files";
import {useAuth} from "../../contexts/auth";
import {MONEY_FORMAT, VOLUME_FORMAT} from "./number-formats";


const AddContractPage = () => {
    //region contract
    let formRef = [useRef(null)]
    const history = useHistory();
    const {selectedDog} = useAuth()
    const [disabledForms, setDisabledForms] = useState(false)
    const validateRequiredRef = useRef(false)
    const setValidateRequiredFlag = (value) => {
        validateRequiredRef.current = !!value
    }
    const requiredWhenSubmitting = (e) => {
        if (!validateRequiredRef.current) return true
        const v = e?.value
        return !(v === undefined || v === null || v === '')
    }

    const [loading, setLoading] = useState(false)
    const [reqs, setReqs] = useState([])
    const [selectedReq, setSelectedReq] = useState({})
    const [didLoad, setDidLoad] = useState(false);
    const [popupErrorVisible, setPopupErrorVisible] = useState(false);
    const [popupErrorText, setPopupErrorText] = useState('');
    const [popupIcon, setPopupIcon] = useState(null);
    const [popupTitle, setPopupTitle] = useState("Ошибка");
    const [popupWidth, setPopupWidth] = useState(500);
    const [popupClassNameColorIcon, setPopupClassNameColorIcon] = useState(null);
    const [onOk, setOnOk] = useState(null);
    const onCancel= () => {setPopupErrorVisible(false)};
    const onCancelWithOk = () => {setPopupErrorVisible(false)};
    const [btnVisibleCancel, setBtnVisibleCancel] = useState(false);
    const [visibleAddOldFiles, setVisibleAddOldFiles] = useState(false)
    const [dogDocList, setDogDocList] = useState([])
    const [newdogFiles, setNewdogFiles] = useState(new Map())
    //endregion

    const appendFormValue = (fd, key, value) => {
        if (value === undefined || value === null || value === '') return
        if (typeof value === 'boolean') {
            fd.append(key, value ? 'true' : 'false')
            return
        }
        fd.append(key, value)
    }

    const onSendRequest = async () => {
        setValidateRequiredFlag(true)
        if (!(await validForms())) {
            return
        }
        const formData = formRef[0]?.current?.instance?.option('formData') || {}
        Object.assign(selectedReq, formData)
        const priceKwh = Number(selectedReq.price_kwh)
        const newPrice = Number(selectedReq.new_contr_price)
        if (Number.isFinite(newPrice) && Number.isFinite(priceKwh) && priceKwh > 0) {
            selectedReq.new_vol = Math.round(newPrice / priceKwh)
        } else if (selectedReq.new_vol === '' || selectedReq.new_vol == null) {
            selectedReq.new_vol = 0
        }
        if (selectedReq.incl_plan_vol !== true) {
            selectedReq.incl_plan_vol = false
        }
        const fd = new FormData()
        Object.entries(selectedReq).forEach(([key, value]) => {
            appendFormValue(fd, key, value)
        })
        if (!fd.has('incl_plan_vol')) {
            fd.append('incl_plan_vol', 'false')
        }
        if (!fd.has('new_vol')) {
            fd.append('new_vol', String(selectedReq.new_vol ?? 0))
        }
        await addFiles(fd)
        try {
            setLoading(true)
            await createPdfChangeSoglasie(fd)
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            setLoading(false)
            setValidateRequiredFlag(false)
        }
    }

    const showNotify = async (text, title = 'Ошибка') =>{
        setPopupErrorText(text)
        setPopupIcon(faTriangleExclamation)
        setPopupTitle(title)
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(500)
        setPopupErrorVisible(true)
        setBtnVisibleCancel(false)
        setOnOk(() => () => {
            setPopupErrorVisible(false)
        })
    }


    const createPdfChangeSoglasie = async(fd) =>{
            // update заявки
        const res = await changeContract(fd)
        if (res.isOk) {
            const data = res.data
            let fileDownload = require('js-file-download')
            fileDownload(Buffer.from(data.pdf_data.data), data.pdf_filename)
            notify(res.message, 'success', 3000)
        } else {
            notify(res.message, 'error', 5000)
            return res
        }
    }

    const withAgreementDefaults = (e) => ({
        ...e,
        new_contr_price: e.new_contr_price || null,
        incl_plan_vol: e.incl_plan_vol === true,
        app_contact: null,
        app_phone: null,
        app_email: null,
    })

    const pickInitialContract = (list) => {
        if (!list?.length) return null
        const kodDog = selectedDog?.kodDog
        if (kodDog != null) {
            const match = list.find((e) => Number(e.kod_dog) === Number(kodDog))
            if (match) return match
        }
        return list[0]
    }

    const getListZayavka = async () => {
        setLoading(true)
        const res = await getContracts('price_change')
        if (res.isOk) {
            res.data = res.data?.map(withAgreementDefaults)
            setReqs(res.data)
            if (res.data && res.data.length > 0 && !selectedReq?.id) {
                const initial = pickInitialContract(res.data)
                setSelectedReq(initial)
                setDisabledForms(false)
            } else if (res.data && res.data.length > 0) {
                const obj = res.data.find((e) => e.id === selectedReq.id)
                if (obj) {
                    setSelectedReq(obj)
                    setDisabledForms(false)
                } else {
                    const initial = pickInitialContract(res.data)
                    setSelectedReq(initial)
                    setDisabledForms(false)
                }
            } else if (res.data && res.data.length === 0) {
                setSelectedReq({})
                setDisabledForms(true)
            }
        } else {
            notify(res.message,'error',10000)
        }
        setLoading(false)
    }



    useEffect(() => {
        (async function(){
            if (!didLoad) {
                setDogDocList([{id: 0,nameType: "Документ к соглашению",dogkindId: "0",needUse: "0", fillOrder: "100",info: null}])
                await getListZayavka()
                setDidLoad(true);
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[didLoad])

    // валидация форм
    const validForms = async () => {
        // boolFormRef === undefined → все формы обнаружены
        let boolFormRef = formRef.find(e => {
            return !e?.current
        })
        if (!boolFormRef) {
            // валидируем все формы
            let result = formRef.map(e => {
                return e.current.instance.validate()
            })
            boolFormRef = result.find(e => {
                return !e.isValid
            })
            if (!boolFormRef) {
                return true
            } else {
                let messageError = ''
                result.map(e => {
                    return e.brokenRules.map(rule => {
                        messageError += '<li>' + rule.message + '</li>'
                        return null
                    })
                })
                await showNotify(`<ol>${messageError}</ol>`)
                return false
            }
        }
    }

    // select договора
    const onChangeDogovor = async (e) => {
        const selected = reqs.find(item => item.id === e.value)
        if (selected) {
            setSelectedReq(selected)
        } else {
            setSelectedReq(reqs[0])
        }
        setDisabledForms(false)
    }

    const formatIsoRu = (iso) => {
        if (!iso || typeof iso !== 'string') return ''
        const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/)
        return m ? `${m[3]}.${m[2]}.${m[1]}` : iso
    }
    const periodCaption = (data) => {
        if (!data) return ''
        const from = formatIsoRu(data.contr_date_start)
        const to = formatIsoRu(data.contr_date_stop)
        if (from && to) return `${from}–${to}`
        if (from) return `с ${from}`
        if (to) return `по ${to}`
        return data.year ? String(data.year) : ''
    }
    const contractCaption = (data) => {
        if (!data) return ''
        const nb = (data.nb_doc && String(data.nb_doc).trim() !== String(data.ndog || '').trim())
            ? data.nb_doc
            : null
        return [data.ndog, nb, periodCaption(data), data.name].filter(Boolean).join(' ')
    }
    const renderField = (data) => {
        return (
            <TextBox value={contractCaption(data)}/>
        );
    }

    const addFileToReq = async (type, files) => {
        const source = new Map(newdogFiles)
        if (files.length > 0) {
            files.forEach(e => {
                if (!e.delfiles) {
                    source.set(e.name, {
                        id: source.size + 1000000,
                        file_name: e.name,
                        file: e,
                    })
                } else {
                    source.delete(e.name)
                }
            })
        }
        setNewdogFiles(source)
    }

    const addFiles = async (fd) => {
        //region прикрепляем все файлы к заявке
        if (newdogFiles.size > 0) {
            for (let newDogFile of newdogFiles.keys()) {
                fd.append('document', newdogFiles.get(newDogFile).file)
            }
            newdogFiles.clear();
        }
        //endregion
    }

    const recalcPlanVolume = (new_contr_price) => {
        const priceKwh = selectedReq?.price_kwh;
        setSelectedReq(prev => ({
            ...prev,
            new_vol: (new_contr_price && priceKwh && priceKwh > 0)
                ? Math.round(new_contr_price / priceKwh)
                : '',
        }));
    };

    return (
        <div className={'content-block dx-card responsive-paddings budget'}>
            <>
                <LoadPanel visible={loading} />
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileLines} />
                <h3><strong>Бюджетный потребитель{/*<ZagolovokFromMenu/>*/}</strong></h3>
                Формирование соглашения об изменении цены действующего контракта (договора)
                <SelectBox labelMode={'floating'} label={'Контракт (договор)'} className="big-input mt-4"
                           noDataText="Нет контрактов для отображения"
                           placeholder="Выберите контракт.."
                           dataSource={reqs}
                           displayExpr="name"
                           valueExpr={"id"}
                           value={selectedReq.id ? selectedReq.id : null}
                           onValueChanged={(e) => {
                               setValidateRequiredFlag(false)
                               onChangeDogovor(e);
                           }}
                           searchEnabled={true}
                           itemRender={(e) => {
                               const nb = (e.nb_doc && String(e.nb_doc).trim() !== String(e.ndog || '').trim())
                                   ? e.nb_doc
                                   : null
                               const period = periodCaption(e)
                               return (
                                   <div>
                                       <span className='small'>{e.ndog}</span>
                                       {nb ? <> {nb}</> : null}
                                       {period ? <> {period}</> : null}
                                       {' '}{e.name}
                                   </div>
                               )
                           }}
                           fieldRender={renderField}

                >
                </SelectBox>
                        <form className={'mt-4'}>
                            <Form
                                disabled={disabledForms}
                                ref={formRef[0]}
                                formData={selectedReq}
                                id="budget-form3"
                                labelMode="floating"
                                labelLocation="left"
                            >
                                    {/* --- Руководитель (подписант) --- */}
                                    <Item dataField="signer_name" editorType="dxTextBox" isRequired={true}>
                                        <Label text={"ФИО руководителя (подписанта)"} />
                                        <CustomRule message="ФИО обязательно" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="signer_title" editorType="dxTextBox" isRequired={true}>
                                        <Label text={"Должность руководителя (подписанта)"} />
                                        <CustomRule message="Должность обязательна" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                        <Item  colSpan={2} dataField="auth_basis" editorType="dxTextBox" isRequired={true}>
                                            <Label text={"Действует на основании"} />
                                        <CustomRule message="Основание обязательно" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        </Item>
                                <GroupItem colCount={2}>
                                    {/*<Item dataField="price_kwh" editorType="dxNumberBox" editorOptions={{ disabled: true }}>
                                        <Label text={"Цена за 1 кВтч с НДС, руб."} />
                                    </Item>*/}
                                    <Item dataField="contr_price" editorType="dxNumberBox"  editorOptions={{ disabled: true, format: MONEY_FORMAT }}>
                                        <Label text={"Цена контракта (договора), руб."} />
                                    </Item>
                                    <Item dataField="vol" editorType="dxNumberBox"  editorOptions={{ disabled: true, format: VOLUME_FORMAT }}>
                                        <Label text={"Объем контракта (договора), кВтч"} />
                                    </Item>
                                </GroupItem>
                                <GroupItem colCount={2}>
                                    <Item dataField="new_contr_price" editorType="dxNumberBox" editorOptions={{
                                        format: MONEY_FORMAT,
                                        onValueChanged: (e) => recalcPlanVolume(e.value)
                                    }} isRequired={true}>
                                        <Label text={"Новая цена контракта (договора), руб."} />
                                        <CustomRule message="Новая цена контракта обязательна" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="new_vol" editorType="dxNumberBox" editorOptions={{ disabled: true, format: VOLUME_FORMAT }}>
                                        <Label text={"Новый объем контракта (договора), кВтч"} />
                                    </Item>
                                </GroupItem>
                                <Item colSpan={2} dataField={'incl_plan_vol'} editorType={'dxCheckBox'}  editorOptions={{
                                    text: 'Включать планируемый объем в контракт'
                                }}>
                                    <Label visible={false} />
                                </Item>

                                {/* --- Контактное лицо --- */}
                                <GroupItem colSpan={2}>
                                    <h4 className="form-subtitle">Контактное лицо по соглашению</h4>
                                </GroupItem>
                                <GroupItem colCount={3}>
                                    <Item dataField="app_contact" editorType="dxTextBox" editorOptions={{ valueChangeEvent: "keyup" }} isRequired={true}>
                                        <Label text={"ФИО"} />
                                        <CustomRule message="ФИО обязательно" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="app_phone" editorOptions={{ mask: '+7 (000) 000-0000' }} editorType="dxTextBox" isRequired={true}>
                                        <Label text={"Телефон"} />
                                        <CustomRule message="Телефон обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                    </Item>
                                    <Item dataField="app_email" editorType="dxTextBox" editorOptions={{ mode: 'email' }} isRequired={true}>
                                        <Label text={"Email"} />
                                        <CustomRule message="Email обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        <EmailRule message="Email задан неверно" />
                                    </Item>
                                </GroupItem>
                            </Form>
                        </form>
                        <div className={'my-3'}>
                            <ul>
                                {
                                    Array.from(newdogFiles.keys()).map(e => (
                                        <li key={e}>{e}</li>
                                    ))
                                }
                            </ul>
                            <Button className="" text="Добавить документы" icon="add" onClick={() => {
                            setVisibleAddOldFiles( true )
                        }}/>
                            <div className="my-1">
                                <span className="text-secondary">При изменении ФИО, должности или основания необходимо прикрепить документ</span>
                            </div>
                            <NewdogFiles typeFileLimit={'newdog'} maxLengthFileName={124} visible={visibleAddOldFiles}
                                         types={dogDocList} onClose={() => setVisibleAddOldFiles( false )}
                                         onAddFiles={addFileToReq} visibleSelectBox={true}/>
                        </div>
                        <p className={'my-3'}>Направьте соглашение в ООО «Р-Энергия» для подписания в системе электронного документооборота.</p>

                <div className='mt-4 float-right mr-4'><Button onClick={() => onSendRequest()} className="block" icon="email" disabled={disabledForms} type={'default'} text="Сформировать соглашение" hint="Отправить заявку" /></div>
                <div className='mt-4 float-right mr-4'><Button className="align-self-end block" disabled={disabledForms} text="< Назад" hint="Назад" onClick={() => history.push('/budget')}/></div>
                <ErrorPopup text={popupErrorText}
                            icon = {popupIcon}
                            width={popupWidth}
                            title ={popupTitle}
                            btnVisible={true}
                            visible={popupErrorVisible}
                            onOk={onOk}
                            classNameColorIcon={popupClassNameColorIcon}
                            btnVisibleCancel={btnVisibleCancel}
                            onCancel={onCancel}
                            onCancelWithOk={onCancelWithOk ?? onCancel}
                />
            </>
        </div>
    )
}

export default AddContractPage
